import React from "react";

import { useError } from "../../hooks";

function ErrorWrapper({ className, style, Component = () => null, name }) {
  const { error } = useError();
  return (
    <div
      className={className}
      style={{
        ...((name === "editor" || name === "upload") && !error?.[name]
          ? { display: "none" }
          : {}),
        ...style,
      }}
    >
      <Component
        {...(error?.isLabeled
          ? {
              style: {
                color: "red",
              },
            }
          : {})}
      />

      <label
        style={{
          color: "red",
          fontSize: 16,
          marginBottom: "0px !important",
          ...(name === "type" ? {} : {}),
        }}
      >
        {error?.[name] || ""}
      </label>
    </div>
  );
}

export default ErrorWrapper;
